/* eslint-disable react/jsx-filename-extension */
import React from "react";
import { graphql } from "gatsby";
import { mergeCraftPreview, resolveImage } from "@dataResolvers";
import { BlogIndex as PageTemplate } from "@pageTemplates";

export const query = graphql`
  query BlogIndexQuery {
    craft {
      entries(section: "blog") {
        title
        url
        postDate
        uid
        ... on Craft_blog_blog_Entry {
          excerpt: descriptor0
          topics {
            ...on Craft_topic_Category {
              title
              uid
            }
          }
          types {
            ... on Craft_blogType_Category {
              title
              uid
            }
          }
          image: image0 {
            width
            height
            hasFocalPoint
            slug
            status
            title
            focalPoint
            url
          }
          author: blogAuthor {
            ... on Craft_author_author_Entry {
              title
              uid
            }
          }
        }
      }
      entry(section: "blogIndex") {
        ... on Craft_blogIndex_blogIndex_Entry {
          url
          #Meta
          metaTitle
          metaImage {
            width
            height
            hasFocalPoint
            slug
            status
            title
            focalPoint
            url
          }
          metaDescription
          #Hero
          heroHeading
        }
      }
    }
  }
`;

const previewQuery = `
  query BlogIndexQuery {
    craft {
      entries(section: "blog") {
        title
        url
        postDate
        uid
        ... on Craft_blog_blog_Entry {
          excerpt: descriptor0
          topics {
            ...on Craft_topic_Category {
              title
              uid
            }
          }
          types {
            ... on Craft_blogType_Category {
              title
              uid
            }
          }
          image: image0 {
            width
            height
            hasFocalPoint
            slug
            status
            title
            focalPoint
            url
          }
          author: blogAuthor {
            ... on Craft_author_author_Entry {
              title
              uid
            }
          }
        }
      }
      entry(section: "blogIndex") {
        ... on Craft_blogIndex_blogIndex_Entry {
          url
          #Meta
          metaTitle
          metaImage {
            width
            height
            hasFocalPoint
            slug
            status
            title
            focalPoint
            url
          }
          metaDescription
          #Hero
          heroHeading
        }
      }
    }
  }
`;

const dataResolver = ({ craft }) => {
  const {
    title,
    url,
    // Hero
    heroHeading,
    // Meta
    metaTitle,
    metaDescription,
    metaImage,
  } = craft.entry;

  // create empty objects to populate categories in use
  let types = {};
  let topics = {};

  const insights = craft.entries.forEach(insight => {
    // resolve the insight
    const newType = { [insight.types[0].uid]: insight.types[0].title  };
    const newTopic = insight.topics.forEach((topic, i) => {
      topics[topic.uid] = topic.title;
    });
    // spread and merge objects to augment list
    types = { ...types, ...newType};
    topics = { ...topics, ...newTopic};
  });

  return {
    title,
    url,
    hero: {
      heading: heroHeading,
      backgroundColor: "darkBlue",
      textColor: "yellow",
      fingerprint: "fingerprintsSimple",
      fingerprintAngle: "0",
      fingerprintColor: "lightBlue",
    },
    posts: craft?.entries?.map((post, i) => {
      return {
        ...post,
        author: post?.author?.[0].title,
        date: post.postDate,
        image: resolveImage(post.image),
        type: post.types[0],
        topics: post.topics.map(topic => topic.uid),
      };
    }),
    filters: {
      insights: types,
      topics,
    },
    meta: {
      title,
      metaTitle,
      metaDescription,
      metaImage: resolveImage(metaImage),
    },
  };
};

const QueryContainer = ({ data, pageContext }) => {
  const { slug: _slug } = pageContext;
  const merged = mergeCraftPreview(data, previewQuery, {
    slug: _slug,
    site: process.env.GATSBY_CRAFT_SITE_HANDLE,
  });

  // When previewing unpublished pages, merged will be empty until
  // the preview reqeust has finished, so returning null to avoid
  // component errors about missing content.
  if (!merged) {
    return null;
  }

  const resolvedData = dataResolver(merged);

  return <PageTemplate data={resolvedData} />;
};

export default QueryContainer;
